import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { TITLES_PUBLISHED } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';

@Component({
  selector: 'app-titles-published',
  templateUrl: './titles-published.component.html',
  styleUrls: ['./titles-published.component.css'],
})
export class TitlesPublishedComponent implements OnInit {
  constructor(private _requestService: RequestService) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  responseData: any = [];
  searchBtnText: string = 'Search';
  selectedFormat: string = '';
  dateModified: string = '';
  listFormat: any = [];
  startDate: string = '';
  endDate: string = '';
  selectStarFilterDate: any = [];
  selectEndFilterDate: any = [];
  successToastShow: boolean = false;
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  ngOnInit(): void {
    this.listFormat = [
      'Book',
      'Video',
      'Course',
      'Practice Exam',
      'AudioBook',
      'Tech Sessions',
      'Exam Trainer',
    ];
    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = TITLES_PUBLISHED) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      format: this.selectedFormat,
      selectedStartDate: Object.assign({}, this.selectStarFilterDate),
      selectedEndDate: Object.assign({}, this.selectEndFilterDate),
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      TITLES_PUBLISHED,
      {
        is_download: 1,
        format: this.selectedFormat,
        selectedStartDate: Object.assign({}, this.selectStarFilterDate),
        selectedEndDate: Object.assign({}, this.selectEndFilterDate),
        page: this.currentPage,
      },
      '',
      'titles_published'
    );
  }

  updateSelectedType(event: any) {
    //console.log(event);

    if (event.name == 'format') {
      this.selectedFormat = event.selectedOption;
    }

    console.log(this.selectedFormat);
  }

  updateSelectedDate(event: any) {
    console.log(event);

    if (event.type == 'startDate') {
      this.selectStarFilterDate['date'] = event.dateString;
    }

    if (event.type == 'endDate') {
      this.selectEndFilterDate['date'] = event.dateString;
    }
    console.log(this.selectStarFilterDate, this.selectEndFilterDate);
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      format: this.selectedFormat,
      selectedStartDate: Object.assign({}, this.selectStarFilterDate),
      selectedEndDate: Object.assign({}, this.selectEndFilterDate),
      page: this.currentPage,
    });

    if (
      (this.selectStarFilterDate['date'] &&
        this.selectEndFilterDate['date'] &&
        !this.selectedFormat) ||
      (this.selectedFormat &&
        !this.selectStarFilterDate['date'] &&
        !this.selectEndFilterDate['date']) ||
      (this.selectedFormat &&
        this.selectStarFilterDate['date'] &&
        this.selectEndFilterDate['date'])
    ) {
      console.log('true');
      this.loadProducts(this.createPostData());
    } else {
      console.log('false');
      this.successToastShow = true;
      this.searchBtnText = 'Search';
      this.showSearchLoading = false;
    }
    // this.loadProducts(this.createPostData());
    // this.searchBtnText = 'Search';
    // this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    (this.selectedFormat = ''),
      (this.selectStarFilterDate = ''),
      (this.selectEndFilterDate = ''),
      this.clearAllDropDowns();
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }
}
